/** @format */

import { Address } from '../address/address.interface';
import { Adjustment } from './adjustment.interface';
import { OrderItem } from './order-item.interface';
import { Payment } from './payments.interface';
import { StoreInfo } from './store-info.interface';

export interface TrackingData {
  trackingUrl: string;
}

export interface Order {
  adjustments: Adjustment[];
  billingAddress?: Address;
  grandTotal: number;
  isEstimatedTax: boolean;
  isFreeShipping?: boolean;
  items: OrderItem[];
  manualAdjustments: Adjustment[];
  orderNumber: number;
  orderType: string;
  // analytics only
  paymentType: string;
  payments: Payment[];
  placedDate: Date;
  status: string;
  storeChain: string;
  storeInfo: StoreInfo;
  storeUniqueId?: number;
  subTotal: number;
  totalAdjustment: number;
  totalManualAdjustment: number;
  totalShippingCharge: number;
  totalTax: number;
  trackingData: TrackingData[];
  trackingNumber?: string | null;
  trackingUrl?: string | null;
  updatedTotal: number;
  zipCode: string;
  errorCard?: boolean;
}
